import { render } from "./TableDropdown.vue?vue&type=template&id=16e04274"
import script from "./TableDropdown.vue?vue&type=script&lang=js"
export * from "./TableDropdown.vue?vue&type=script&lang=js"
script.render = render

export default script